module.exports = __webpack_public_path__ + "static/media/inventory.652254a9.svg";